// extracted by mini-css-extract-plugin
module.exports = {"pendingCall":"DraftApproved__pendingCall___D5hu9"};